import {
  Message,
  messageQueryKey,
  useQueryGetAllMessagesByConversationId,
} from "@apis:message/message";
import { convertMessagesToChat } from "@pages:app/talk/Chat/components/utils/message";
import { useQueryClient } from "@tanstack/react-query";

export const useGenerateChatMessages = (conversationId: string) => {
  const { data: messages, isLoading } = useQueryGetAllMessagesByConversationId({
    conversationId,
  });

  return { data: convertMessagesToChat(messages), isLoading };
};

export const useMessageToConversation = () => {
  const queryClient = useQueryClient();

  return (message: Partial<Message["GET_ONE"]["Response"]>) => {
    queryClient.setQueryData(
      messageQueryKey.getAllMessagesByConversationId({
        conversationId: message.conversationId as string,
      }).queryKey,
      (old: Partial<Message["GET_ONE"]["Response"]>[] | undefined) => {
        if (old) {
          return [...old, message];
        }
        return [message];
      },
    );
  };
};

export const usePartialUpdateLastMessageByConversationId = (
  conversationId: string,
) => {
  const queryClient = useQueryClient();

  return (
    updater: (
      oldMessage: Partial<Message["GET_ONE"]["Response"]>,
    ) => Partial<Message["GET_ONE"]["Response"]>,
  ) => {
    queryClient.setQueryData(
      messageQueryKey.getAllMessagesByConversationId({
        conversationId: conversationId as string,
      }).queryKey,
      (old: Partial<Message["GET_ONE"]["Response"]>[] | undefined) => {
        if (old && old.length > 0) {
          const lastConversation = old.pop() as Partial<
            Message["GET_ONE"]["Response"]
          >;
          return [...old, updater(lastConversation)];
        }
        return [];
      },
    );
  };
};
